exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body.theme-dark .top-bar {\n  background-color: #293145; }\n\nbody.theme-dark .menu-w {\n  background-image: none !important;\n  background-color: #202124; }\n", ""]);

// exports
